import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(name, set1, set2, set3, set4) {
  return { name, set1, set2, set3, set4 };
}

const rows = [
  createData('Cela05-Providencia', 159, 6.0, 24, 4.0),
  createData('Cela07-Providencia', 237, 9.0, 37, 4.3),
  createData('prueba', 262, 16.0, 24, 6.0),
];

export default function CustomizedTables() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ maxWidth: '100%' }} aria-label="customized table">
        <TableHead>
          <TableRow >
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', fontWeight: 600 }}>
            Usuario
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Cantidad
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Fallidas
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            % Fallidas
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Tiempo Facturable
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            % Tiempo Facturable
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000', }} align="right">
            Duración promedio
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Tiempo total Ring
            </StyledTableCell>

            <StyledTableCell style={{ backgroundColor: 'lightgrey', color: '#000' }} align="right">
            Promedio Ring
            </StyledTableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="right">{row.set1}</StyledTableCell>
              <StyledTableCell align="right">{row.set1}</StyledTableCell>
              <StyledTableCell align="right">{row.set2}</StyledTableCell>
              <StyledTableCell align="right">{row.set2}</StyledTableCell>
              <StyledTableCell align="right">{row.set2}</StyledTableCell>
              <StyledTableCell align="right">{row.set3}</StyledTableCell>
              <StyledTableCell align="right">{row.set3}</StyledTableCell>
              <StyledTableCell align="right">{row.set3}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
